import { render, staticRenderFns } from "./matter-work-line-items.vue?vue&type=template&id=107ab624&scoped=true&"
import script from "./matter-work-line-items.vue?vue&type=script&lang=ts&"
export * from "./matter-work-line-items.vue?vue&type=script&lang=ts&"
import style0 from "./matter-work-line-items.vue?vue&type=style&index=0&id=107ab624&prod&lang=scss&scoped=true&"
import style1 from "./matter-work-line-items.vue?vue&type=style&index=1&id=107ab624&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ab624",
  null
  
)

export default component.exports